import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { a11yProps, TabPanel } from "..";
import PlayerAlertVideoList from "../PlayerAlertVideo/PlayerAlertVideoList";

function AdsVideosList({
  listOfMedia,
  setIsActive,
}: {
  listOfMedia: any[];
  setIsActive: any;
}) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setIsActive(newValue === 0 ? true : false);
  };
  return (
    <Box>
      <Box>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Available" {...a11yProps(0)} />
          <Tab label="Trash" {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <PlayerAlertVideoList title={"Video"} listOfMedia={listOfMedia} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PlayerAlertVideoList title={"Video"} listOfMedia={listOfMedia} />
        </TabPanel>
      </Box>
    </Box>
  );
}

export default AdsVideosList;
